import script from "./EditColumns.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditColumns.vue?vue&type=script&setup=true&lang=ts"

import "./EditColumns.vue?vue&type=style&index=0&id=ee02ba96&lang=scss"

const __exports__ = script;

export default __exports__